import { useQuery } from '@tanstack/react-query';
import { getApiBaseUrl } from '@/lib/api-base-url';
import { authFetch } from '@/lib/auth-fetch';

export interface PendingReferenceExecution {
  id: string;
  orderId: string | null;
  hedgeRequestId: string | null;
  direction: string;
  quantityMt: string;
  executedPrice: string;
  executedPriceCurrency: string;
  executionDate: string;
  executionType: string;
  instrument: string;
  createdAt: string;
}

async function fetchPendingReferences(): Promise<PendingReferenceExecution[]> {
  const response = await authFetch(`${getApiBaseUrl()}/hedging/executions/pending-references`);
  if (!response.ok) {
    throw new Error(`Request failed (${String(response.status)})`);
  }
  return (await response.json()) as PendingReferenceExecution[];
}

export const HEDGING_PENDING_REFERENCES_QUERY_KEY = ['hedging', 'pending-references'] as const;

export function usePendingReferences() {
  return useQuery({
    queryKey: HEDGING_PENDING_REFERENCES_QUERY_KEY,
    queryFn: fetchPendingReferences,
  });
}
